import { useTranslation } from 'react-i18next';

import { useExternalHomepageConfig } from '../../../hooks/useExternalHomepageConfig';
import { isRemix } from '../../../utils/ssrUtils';
import { AnchorWrapper } from './AnchorWrapper';
import { FooterItem } from './types';

export const useAboutNavigationItem = (className: string): FooterItem => {
  const { t } = useTranslation();
  const { getHomepageUrl } = useExternalHomepageConfig();

  return {
    title: t('navbar.about', 'About'),
    isDropdown: true,
    list: [
      <AnchorWrapper
        className={className}
        key="about-sim-local"
        url={getHomepageUrl('/about-us/about-sim-local')}
      >
        {t('navbar.about_sim_local', 'About Sim Local')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="networks"
        url={isRemix() ? '/networks' : getHomepageUrl('/networks')}
      >
        {t('navbar.our_networks', 'Our Networks')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="about-us-careers"
        url={getHomepageUrl('/about-us/careers')}
      >
        {t('navbar.careers', 'Careers')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="partners"
        url={getHomepageUrl('/partners')}
      >
        {t('navbar.partners', 'Partners')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="affiliates"
        url={getHomepageUrl('/affiliates')}
      >
        {t('navbar.affiliates', 'Affiliates')}
      </AnchorWrapper>,
      <AnchorWrapper
        className={className}
        key="news"
        url={isRemix() ? '/news' : getHomepageUrl('/news')}
      >
        {t('navbar.blog', 'Blog')}
      </AnchorWrapper>,
    ],
  };
};
